import qs from 'qs';
export const queryBuilder = (obj: Record<string, any>, basePath = '/global'): string =>
	`${basePath}?${qs.stringify(obj, { encode: false, arrayFormat: 'indices' })}`;
